import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { register } from "../../store/iam/operations";
import { isRegistrationAndAuthenticationInProgress } from "../../store/iam/selectors";
import { RegisterForm } from "../../components/auth";


interface Props {
    isLoading: boolean;
    register: (email: string, first_name: string, last_name: string, password: string, token: string, onError: () => void, navigate: NavigateFunction) => void;
}


function Register({ isLoading, register }: Props) {
    const navigate = useNavigate();

    const [shouldResetCaptcha, setShouldResetCaptcha] = useState(false);

    const onError = () => {
        setShouldResetCaptcha(true);
    };

    const submitForm = (email: string, first_name: string, last_name: string, password: string, token: string) => {
        setShouldResetCaptcha(false);
        register(email, first_name, last_name, password, token, onError, navigate);
    };

    return (
        <RegisterForm
            onSubmit={submitForm}
            isLoading={isLoading}
            shouldResetCaptcha={shouldResetCaptcha}
            push={navigate}
        />
    );
}

const mapStateToProps = (state: any) => ({
    isLoading: isRegistrationAndAuthenticationInProgress(state)
});

export default connect(mapStateToProps, { register })(Register);
